/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { observable, action, makeObservable } from "mobx";
import { persist } from "mobx-persist";
import FlashMessage from "models/FlashMessage";
import { StoreBase } from "./StoreBase";

export class ContextStore extends StoreBase {
  constructor() {
    super();
    makeObservable(this);
  }

  @observable
  @persist("list")
  public flashMessages: FlashMessage[] = [];

  @action.bound
  public showMessage(message: FlashMessage): void {
    this.flashMessages.push(message);
  }

  @action.bound
  public removeMessage(id: string): void {
    const index = this.flashMessages.findIndex((element) => element.id === id);

    this.flashMessages.splice(index);
  }
}

export default ContextStore;
